import { render, staticRenderFns } from "./TabMotion.vue?vue&type=template&id=87858484&scoped=true&"
import script from "./TabMotion.vue?vue&type=script&lang=ts&"
export * from "./TabMotion.vue?vue&type=script&lang=ts&"
import style0 from "./TabMotion.vue?vue&type=style&index=0&id=87858484&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87858484",
  null
  
)

export default component.exports